<template>
  <div>
    <Layout ref="layoutRef" :selectedOption="1" />

    <!-- Breadcrumb y ayuda -->
    <div class="mb-3">
      <div class="row align-items-center">
        <div class="col-11">
          <div class="breadcrumb-container">
            <router-link to="/medico">Médicos</router-link>
            &rsaquo;
            {{ datoMedico.nombreCompleto }}
          </div>
        </div>
        <div class="col-1 text-end">
          <span
            class="material-symbols-outlined"
            style="font-size:32px; color:blue; cursor:pointer"
            @click="showModalHelp = true"
          >help</span>
        </div>
      </div>
    </div>
    <Modal v-model:modelValue="showModalHelp" title="Ayuda: Agenda">
      <AyudaMedicoAgenda />
    </Modal>
    <hr />

<!-- Datos del Médico -->
<div class="card shadow-sm mb-4">
  <div class="card-header bg-light fw-bold">Datos del Médico</div>
  <div class="card-body">
<div class="row g-3">
  <div class="col-md-6">
    <label class="form-label small fw-bold">Nombre</label>
    <p class="form-control-plaintext fw-normal">{{ datoMedico.nombreCompleto }}</p>
  </div>
  <div class="col-md-3">
    <label class="form-label small fw-bold">Documento</label>
    <p class="form-control-plaintext fw-normal">{{ datoMedico.personaDocumento }}</p>
  </div>
  <div class="col-md-2 d-flex align-items-center justify-content-end gap-2">
    <label class="form-label small fw-bold mb-0">Agendar sábado</label>
    <label class="switch mb-0">
      <input
        type="checkbox"
        v-model="datoMedico.agendarSab"
        true-value="1"
        false-value="0"
        @change="guardarMedico"
      />
      <span class="slider round"></span>
    </label>
  </div>
  <div class="col-md-6">
    <label class="form-label small fw-bold">Especialidad</label>
    <p class="form-control-plaintext fw-normal">{{ datoMedico.especialidadNombre }}</p>
  </div>
  <div class="col-md-3">
    <label class="form-label small fw-bold">Nro. Profesional</label>
    <p class="form-control-plaintext fw-normal">{{ datoMedico.documento }}</p>
  </div>
  <div class="col-md-2 d-flex align-items-center justify-content-end gap-2">
    <label class="form-label small fw-bold mb-0">Agendar domingo</label>
    <label class="switch mb-0">
      <input
        type="checkbox"
        v-model="datoMedico.agendarDom"
        true-value="1"
        false-value="0"
        @change="guardarMedico"
      />
      <span class="slider round"></span>
    </label>
  </div>
</div>
  </div>
</div>

    <!-- DataTable -->
    <DataTable
      :data="agendas"
      :columns="[
        { label: 'Fecha',      field: 'fecha',
          format: (v) => getFormattedDate(v, 'DD/MM/YYYY') },
        { label: 'Hora desde', field: 'horaDesde' },
        { label: 'Hora hasta', field: 'horaHasta' },
        { label: 'Observación',field: 'observacion' },
      ]"
      idField="idAgenda"
      mensajeVacio="Seleccione una fecha o cargue todos los registros."
      :acciones="true"
      :mostrarBotonNuevo="false"
      :mostrarBotonExcel="true"
      :mostrarInfo="false"
      :mostrarEditar="true"
      :mostrarVer="false"
      :mostrarEliminar="false"
      @refresh="getDataTodos"
      @edit="row => abrirModalEditar(row.idAgenda)"
    >
      <!-- Barra de herramientas extra -->
      <template #acciones-extra>
        <!-- Filtro fecha -->
        <div class="col-auto d-flex align-items-center gap-2">
          <label class="small fw-bold mb-0">Fecha</label>
          <input
            type="date"
            class="form-control form-control-sm"
            v-model="fechaBusqueda"
            :min="hoy"
            @change="getDataFecha"
            style="width:150px"
          />
          <button
            class="btn btn-outline-primary btn-sm d-flex align-items-center gap-1"
            @click="getDataFecha"
            title="Buscar por fecha"
          >
            <span class="material-icons" style="font-size:16px">search</span>
          </button>
        </div>

        <!-- Separador -->
        <div class="col-auto">
          <div style="width:1px; height:28px; background:#dee2e6"></div>
        </div>

        <!-- Nuevo registro -->
        <div class="col-auto">
          <button
            class="btn btn-outline-success btn-sm d-flex align-items-center gap-1"
            data-bs-toggle="modal"
            data-bs-target="#ventanaModal"
            @click="abrirModalCrear"
            title="Nuevo registro"
          >
            <span class="material-icons" style="font-size:16px">add_box</span> Nuevo
          </button>
        </div>

        <!-- Separador -->
        <div class="col-auto">
          <div style="width:1px; height:28px; background:#dee2e6"></div>
        </div>

        <!-- Generar agenda -->
        <div class="col-auto d-flex align-items-center gap-1">
          <button
            class="btn btn-outline-danger btn-sm d-flex align-items-center gap-1"
            @click="generarAgenda('dia')"
            title="Generar Agenda del Día"
          >
            <span class="material-symbols-outlined" style="font-size:16px">event</span> Día
          </button>
          <button
            class="btn btn-outline-danger btn-sm d-flex align-items-center gap-1"
            @click="generarAgenda('mes')"
            title="Generar Agenda del Mes"
          >
            <span class="material-symbols-outlined" style="font-size:16px">date_range</span> Mes
          </button>
          <button
            class="btn btn-outline-danger btn-sm d-flex align-items-center gap-1"
            @click="generarAgenda('anio')"
            title="Generar Agenda del Año"
          >
            <span class="material-symbols-outlined" style="font-size:16px">calendar_month</span> Año
          </button>
        </div>

        <!-- Separador -->
        <div class="col-auto">
          <div style="width:1px; height:28px; background:#dee2e6"></div>
        </div>

<!-- Habilitar/deshabilitar día -->
<div class="col-auto d-flex align-items-center gap-2">
  <select
    id="motivoCancelacion"
    v-model="motivoCancelacion"
    class="form-select form-select-sm"
    style="width:220px"
  >
    <option value="">Seleccione un motivo</option>
    <option value="Enfermedad del médico">Enfermedad del médico</option>
    <option value="Emergencia personal o familiar">Emergencia personal o familiar</option>
    <option value="Emergencias médicas">Emergencias médicas</option>
    <option value="Vacaciones o días libres planificados">Vacaciones o días libres</option>
    <option value="Capacitaciones o conferencias profesionales">Capacitaciones</option>
    <option value="Problemas técnicos o de infraestructura">Problemas técnicos</option>
    <option value="Retrasos en el horario previo">Retrasos en horario</option>
    <option value="Cambio de horario o disponibilidad del médico">Cambio de horario</option>
    <option value="Baja demanda de pacientes">Baja demanda</option>
    <option value="Condiciones meteorológicas adversas">Condiciones meteorológicas</option>
  </select>
  <button
    class="btn btn-sm d-flex align-items-center gap-1"
    :class="diaHabilitado ? 'btn-outline-danger' : 'btn-outline-success'"
    :title="diaHabilitado ? 'Deshabilitar día' : 'Habilitar día'"
    :disabled="!fechaBusqueda"
    @click="toggleHabilitarDia"
  >
    <span class="material-symbols-outlined" style="font-size:16px">
      {{ diaHabilitado ? 'toggle_off' : 'toggle_on' }}
    </span>
    {{ diaHabilitado ? 'Deshabilitar' : 'Habilitar' }}
  </button>
</div>
      </template>

      <!-- Celda personalizada: toggle de estado -->
      <template #cell-estado="{ row }">
        <label class="switch">
          <input
            type="checkbox"
            v-model="row.estado"
            true-value="1"
            false-value="0"
            @change="cambiarEstadoAgenda(row.idAgenda, row.estado)"
          />
          <span class="slider round"></span>
        </label>
      </template>

    </DataTable>

<!-- Modal -->
<div
  class="modal fade"
  id="ventanaModal"
  tabindex="-1"
  aria-labelledby="ventanaModalLabel"
  aria-hidden="true"
  v-if="modalWindow"
>
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header bg-primary">
        <span class="material-icons" style="font-size:24px; color:white">event_note</span>
        <h5 class="modal-title text-white ms-2" id="ventanaModalLabel">{{ titulo }}</h5>
        <button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal"></button>
      </div>

      <div class="modal-body">
        <div class="row g-3">

          <!-- IDs (solo editar) -->
          <template v-if="btnEditar_det">
            <div class="col-md-3">
              <label class="form-label small text-muted">Id Agenda</label>
              <input type="text" class="form-control form-control-sm bg-light"
                v-model="datoAgenda.idAgenda" disabled />
            </div>
            <div class="col-md-3">
              <label class="form-label small text-muted">Id Médico</label>
              <input type="text" class="form-control form-control-sm bg-light"
                v-model="datoAgenda.idMedico" disabled />
            </div>
            <!-- Estado toggle -->
            <div class="col-md-6 d-flex align-items-end justify-content-end pb-1">
              <div class="d-flex align-items-center gap-2">
                <span class="small fw-bold text-muted">Estado:</span>
                <span
                  class="badge"
                  :class="Number(datoAgenda.estado) === 1 ? 'bg-success' : 'bg-danger'"
                >
                  {{ Number(datoAgenda.estado) === 1 ? 'Habilitado' : 'Deshabilitado' }}
                </span>
                <label class="switch mb-0">
                  <input
                    type="checkbox"
                    v-model="datoAgenda.estado"
                    :true-value="1"
                    :false-value="0"
                  />
                  <span class="slider round"></span>
                </label>
              </div>
            </div>
          </template>

          <!-- Fecha, Hora desde, Hora hasta -->
          <div class="col-md-4">
            <label class="form-label fw-bold">Fecha</label>
            <div class="input-group input-group-sm">
              <span class="input-group-text bg-light">
                <span class="material-symbols-outlined" style="font-size:16px">calendar_today</span>
              </span>
              <input type="text" class="form-control bg-light"
                v-model="datoAgenda.fecha" disabled />
            </div>
          </div>
          <div class="col-md-4">
            <label class="form-label fw-bold">Hora desde</label>
            <div class="input-group input-group-sm">
              <span class="input-group-text bg-light">
                <span class="material-symbols-outlined" style="font-size:16px">schedule</span>
              </span>
              <input type="text" class="form-control bg-light"
                v-model="datoAgenda.horaDesde" disabled />
            </div>
          </div>
          <div class="col-md-4">
            <label class="form-label fw-bold">Hora hasta</label>
            <div class="input-group input-group-sm">
              <span class="input-group-text bg-light">
                <span class="material-symbols-outlined" style="font-size:16px">schedule</span>
              </span>
              <input type="text" class="form-control bg-light"
                v-model="datoAgenda.horaHasta" disabled />
            </div>
          </div>

<!-- Motivo + Observación -->
<div class="col-md-12">
  <label class="form-label fw-bold">Motivo</label>
  <select
    class="form-select form-select-sm mb-2"
    v-model="motivoSeleccionado"
    @change="combinarObservacion"
  >
    <option value="">Seleccione un motivo (opcional)</option>
    <option value="Enfermedad del médico">Enfermedad del médico</option>
    <option value="Emergencia personal o familiar">Emergencia personal o familiar</option>
    <option value="Emergencias médicas">Emergencias médicas</option>
    <option value="Vacaciones o días libres planificados">Vacaciones o días libres</option>
    <option value="Capacitaciones o conferencias profesionales">Capacitaciones</option>
    <option value="Problemas técnicos o de infraestructura">Problemas técnicos</option>
    <option value="Retrasos en el horario previo">Retrasos en horario</option>
    <option value="Cambio de horario o disponibilidad del médico">Cambio de horario</option>
    <option value="Baja demanda de pacientes">Baja demanda</option>
    <option value="Condiciones meteorológicas adversas">Condiciones meteorológicas</option>
  </select>
<label class="form-label fw-bold">Observación</label>
<div class="input-group">
  <input
    type="text"
    class="form-control"
    v-model="datoAgenda.observacion"
    style="text-transform:uppercase"
    placeholder="Ingrese una observación..."
    required
  />
  <button
    type="button"
    class="btn btn-outline-secondary"
    title="Limpiar observación"
    @click="datoAgenda.observacion = ''; motivoSeleccionado = ''"
  >
    <span class="material-symbols-outlined" style="font-size:16px">close</span>
  </button>
</div>
</div>

        </div>
      </div>

      <div class="modal-footer">
        <button
          v-if="btnCrear_det"
          type="button"
          class="btn btn-success px-4"
          @click.prevent="guardarAgenda"
        >
          <span class="material-symbols-outlined align-middle">save</span> Guardar
        </button>
        <button
          v-if="btnEditar_det"
          type="button"
          class="btn btn-primary px-4"
          @click.prevent="guardarEditAgenda"
        >
          <span class="material-symbols-outlined align-middle">update</span> Actualizar
        </button>
      </div>

    </div>
  </div>
</div>

    <Footer />
  </div>
</template>

<script>
import Layout from '@/components/Layout.vue';
import Footer from '@/components/Footer.vue';
import DataTable from '@/components/DataTable.vue';
import AyudaMedicoAgenda from '@/views/ayuda/AyudaMedicoAgenda.vue';
//import { validarForm } from '@/modules/validacionesForms.js';
import dateFormat from '@/modules/dateFormat.js';
import api from '@/services/api';
import * as $ from 'jquery';
import swal2 from 'sweetalert2';
window['$'] = $;
window['jQuery'] = $;

export default {
  props: {
    p_idMedico: { type: Number, required: true },
  },

  components: { Layout, Footer, DataTable, AyudaMedicoAgenda },

  data() {
    return {
      // Master
      datoMedico:          {},
      showModalHelp:       false,
      fechaBusqueda:       '',
      hoy:                 new Date().toISOString().split('T')[0],
      motivoCancelacion:   '',
      // Details
      agendas:             [],
      datoAgenda:          {},
      datoAgendaSeleccionado: {},
      titulo:              '',
      btnCrear_det:        false,
      btnEditar_det:       false,
      modalWindow:         true,
      diaHabilitado:       true,
      motivoSeleccionado:  '',
    };
  },

  mounted() {
    this.$refs.layoutRef.toggleProcesos();
    this.$refs.layoutRef.toggleReportes();
    this.$refs.layoutRef.toggleParametros();
    this.$refs.layoutRef.toggleAyuda();
    this.abrirEditar(this.p_idMedico);
  },

  methods: {
    //  Helpers
    getFormattedDate(date) {
      return dateFormat.getFormattedDate(date);
    },

    //  Master
    abrirEditar(idMedico) {
      if (idMedico != null) {
        api.get('/vwmedicos/' + idMedico).then(resp => {
          this.datoMedico = resp.data;
        });
      }
    },

    async guardarMedico() {
      try {
        await api.post('/medicos/guardar-dto', this.datoMedico);
      } catch (error) {
        console.error('Error al guardar médico:', error);
      }
    },

async getDataFecha() {
  if (!this.fechaBusqueda) return;
  const response = await api.get('/vwagendas/por-fecha', {
    params: { idMedico: this.datoMedico.idMedico, fecha: this.fechaBusqueda },
  });
  this.agendas = response.data.sort((a, b) => a.idAgenda - b.idAgenda);

  if (this.agendas.length === 0) {
    this.diaHabilitado = false;
    return;
  }

  this.diaHabilitado = this.agendas.every(a => Number(a.estado) === 1);
},

async toggleHabilitarDia() {
  const nuevoEstado = this.diaHabilitado ? 0 : 1;
  await this.habilitarDia(this.fechaBusqueda, nuevoEstado);
  this.diaHabilitado = !this.diaHabilitado;
},

combinarObservacion() {
  if (!this.motivoSeleccionado) return;
  const obs = this.datoAgenda.observacion?.trim() || '';
  this.datoAgenda.observacion = obs
    ? `${obs} - ${this.motivoSeleccionado}`.toUpperCase()
    : this.motivoSeleccionado.toUpperCase();
},

    async getDataTodos() {
      const response = await api.get('/vwagendas/idmedico/' + this.datoMedico.idMedico);
      this.agendas = response.data.sort((a, b) => a.idAgenda - b.idAgenda);
    },

    //  Modal
    abrirModalCrear() {
      this.datoAgenda    = {};
      this.motivoSeleccionado = '';
      this.titulo        = 'Nueva Agenda';
      this.btnCrear_det  = true;
      this.btnEditar_det = false;
    },

    abrirModalEditar(idAgenda) {
      this.motivoSeleccionado = '';
      this.modalWindow = true;
      if (idAgenda != null) {
        api.get('/vwagendas/' + idAgenda).then(resp => {
          this.datoAgenda = resp.data;
        });
      }
      $('#ventanaModal').modal('show');
      this.titulo        = 'Editar Agenda';
      this.btnCrear_det  = false;
      this.btnEditar_det = true;
    },

    async guardarAgenda() {
      try {
        this.datoAgenda.idMedico = this.datoMedico.idMedico;
        await api.post('/agendas', this.datoAgenda);
        $('#ventanaModal').modal('hide');
        swal2.fire('Correcto!', 'Agenda creada exitosamente!', 'success');
        this.getDataFecha();
      } catch {
        swal2.fire('Error!', 'Inténtelo de nuevo!', 'error');
      }
    },

    async guardarEditAgenda() {
      try {
        await api.post('/agendas', this.datoAgenda);
        $('#ventanaModal').modal('hide');
        swal2.fire('Correcto!', 'Agenda actualizada exitosamente!', 'success');
        this.getDataFecha();
      } catch (error) {
        swal2.fire('Error!', 'Inténtelo de nuevo!', 'error');
        if (error.response?.data?.errors) {
          Object.values(error.response.data.errors).forEach(e =>
            swal2.fire('Error', String(e), 'error')
          );
        }
      }
    },

    async cambiarEstadoAgenda(idAgenda, estado) {
      try {
        const resp = await api.get('/vwagendas/' + idAgenda);
        const dato = { ...resp.data, estado };
        await api.post('/agendas', dato);
        // Sin alerta para no interrumpir el flujo del toggle
      } catch {
        swal2.fire('Error!', 'No se pudo cambiar el estado.', 'error');
      }
    },

    //  Generar agenda
    generarAgenda(fechaTipo) {
      swal2.fire({
        title: 'Procesando...',
        text: 'Por favor, espera mientras se genera la agenda.',
        allowOutsideClick: false,
        showConfirmButton: false,
        didOpen: () => swal2.showLoading(),
      });

      const params = {
        idMedico:   this.datoMedico.idMedico,
        agendarSab: this.datoMedico.agendarSab,
        agendarDom: this.datoMedico.agendarDom,
      };
      const fechaActual = new Date();
      let endpoint = '';

      if (fechaTipo === 'dia') {
        endpoint = 'generar-dia';
        params.fecha = this.fechaBusqueda;
      } else if (fechaTipo === 'mes') {
        endpoint = 'generar-mes';
        params.anio = fechaActual.getFullYear();
        params.mes  = fechaActual.getMonth() + 1;
      } else if (fechaTipo === 'anio') {
        endpoint = 'generar-anio';
        params.anio = fechaActual.getFullYear();
      }

      api.get(`/agendas/${endpoint}`, { params })
        .then( () => {
          if (fechaTipo === 'dia' || fechaTipo === 'mes') {
            this.getDataFecha();
          } else {
            this.getDataTodos();
          }
          swal2.fire({ icon: 'success', title: '¡Éxito!',
            text: `Agenda ${fechaTipo} generada con éxito.` });
        })
        .catch(() => {
          swal2.fire({ icon: 'error', title: 'Error',
            text: 'No se pudo generar la agenda. Inténtalo de nuevo.' });
        });
    },

    //  Habilitar/deshabilitar día
    async habilitarDia(fecha, estado) {
      const params = {
        idMedico:   this.datoMedico.idMedico,
        fechaDesde: fecha,
        fechaHasta: fecha,
        estado,
        observacion: this.motivoCancelacion,
      };
      try {
        await api.put('/agendas/actualizarEstado', {}, { params });
        this.getDataFecha();
      } catch (error) {
        console.error('Error al habilitar/deshabilitar día:', error);
      }
    },
  },
};
</script>

<style scoped>
.breadcrumb-container { font-size: 0.9rem; color: #6c757d; }
.breadcrumb-container a { text-decoration: none; color: #0d6efd; }

/* Toggle switch */
.switch {
  position: relative;
  display: inline-block;
  width: 30px;
  height: 17px;
}
.switch input { opacity: 0; width: 0; height: 0; }
.slider {
  position: absolute;
  cursor: pointer;
  top: 0; left: 0; right: 0; bottom: 0;
  background-color: #ccc;
  transition: .4s;
  border-radius: 17px;
}
.slider:before {
  position: absolute;
  content: "";
  height: 13px;
  width: 13px;
  left: 2px;
  bottom: 2px;
  background-color: white;
  transition: .4s;
  border-radius: 50%;
}
input:checked + .slider { background-color: #2196F3; }
input:focus  + .slider  { box-shadow: 0 0 1px #2196F3; }
input:checked + .slider:before {
  transform: translateX(13px);
}
.slider.round { border-radius: 17px; }
.slider.round:before { border-radius: 50%; }
</style>